export default "__VITE_ASSET__DAMY52_E__"